module.exports = "/_next/static/images/c2522b16f1a77a762eb7120902159b2f-nu-card-xs@2x.jpg";